module.exports = __webpack_public_path__ + "static/media/instagram.5e4ff1c4.png";